var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.364 0.218894C12.8071 -0.0664544 18.2834 -0.0664544 23.793 0.218894C23.7679 0.349223 23.7003 0.420721 23.5902 0.433604C18.2163 0.219324 12.8077 0.147826 7.364 0.218894Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0379 0.219237C28.426 -0.0639645 29.8458 -0.0639645 31.2972 0.219237C31.2721 0.349566 31.2046 0.421064 31.0944 0.433946C29.7803 0.22117 28.4281 0.149671 27.0379 0.219237Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3644 0.21895C12.8081 0.147881 18.2167 0.219379 23.5906 0.433659C21.7643 3.26353 19.9727 6.12625 18.2157 9.02203C18.1142 7.5925 18.0806 6.16103 18.1142 4.72785C14.4627 4.69199 10.8119 4.72785 7.16157 4.8352C4.6311 6.07837 3.78592 8.11811 4.62623 10.9544C5.23188 12.3114 6.21214 13.2061 7.56723 13.6383C15.6128 13.7098 23.6581 13.7815 31.7037 13.853C37.1258 15.3034 39.5259 18.9891 38.904 24.9105C37.9035 28.6179 35.6385 30.9439 32.1093 31.8886C26.4977 32.0318 20.8863 32.0318 15.2747 31.8886C17.134 28.9185 18.9931 25.9482 20.8524 22.9781C20.9538 24.4794 20.9875 25.9824 20.9538 27.487C24.3349 27.5229 27.7155 27.487 31.0952 27.3797C33.8116 26.576 34.9947 24.6795 34.6446 21.6899C34.0962 19.8208 32.9129 18.7117 31.0952 18.3619C22.9145 18.2904 14.7337 18.2187 6.55309 18.1472C1.49316 16.2762 -0.636521 12.5188 0.164038 6.87494C1.2808 3.07931 3.68086 0.860716 7.3644 0.21895Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3644 0.21895C12.8081 0.147881 18.2167 0.219379 23.5906 0.433659C21.7643 3.26353 19.9727 6.12625 18.2157 9.02203C18.1142 7.5925 18.0806 6.16103 18.1142 4.72785C14.4627 4.69199 10.8119 4.72785 7.16157 4.8352C4.6311 6.07837 3.78592 8.11811 4.62623 10.9544C5.23188 12.3114 6.21214 13.2061 7.56723 13.6383C15.6128 13.7098 23.6581 13.7815 31.7037 13.853C37.1258 15.3034 39.5259 18.9891 38.904 24.9105C37.9035 28.6179 35.6385 30.9439 32.1093 31.8886C26.4977 32.0318 20.8863 32.0318 15.2747 31.8886C17.134 28.9185 18.9931 25.9482 20.8524 22.9781C20.9538 24.4794 20.9875 25.9824 20.9538 27.487C24.3349 27.5229 27.7155 27.487 31.0952 27.3797C33.8116 26.576 34.9947 24.6795 34.6446 21.6899C34.0962 19.8208 32.9129 18.7117 31.0952 18.3619C22.9145 18.2904 14.7337 18.2187 6.55309 18.1472C1.49316 16.2762 -0.636521 12.5188 0.164038 6.87494C1.2808 3.07931 3.68086 0.860716 7.3644 0.21895Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0395 0.219086C28.4297 0.14952 29.7819 0.221018 31.096 0.433795C28.8451 4.12873 26.5462 7.77879 24.1999 11.384C22.8097 11.4535 21.4575 11.382 20.1434 11.1693C22.3944 7.47433 24.6932 3.82427 27.0395 0.219086Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5003 11.3837C30.0426 11.4535 28.6228 11.3818 27.241 11.169C29.5852 7.56986 31.8839 3.91981 34.1371 0.218861C35.62 -0.0312758 37.1073 -0.0669175 38.5993 0.111506C36.1554 3.81975 33.789 7.57717 31.5003 11.3837Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1426 11.1689C21.4567 11.3817 22.809 11.4532 24.1992 11.3837C22.811 11.6669 21.3912 11.6669 19.9398 11.3837C19.9649 11.2533 20.0325 11.1818 20.1426 11.1689Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2407 11.1689C28.6226 11.3817 30.0424 11.4534 31.5001 11.3837C30.0444 11.6669 28.5571 11.6669 27.0379 11.3837C27.063 11.2533 27.1306 11.1818 27.2407 11.1689Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56748 20.6163C8.99376 20.5454 10.4136 20.6169 11.8268 20.831C9.52821 24.4811 7.22937 28.1311 4.93073 31.7812C3.44786 32.0313 1.96053 32.067 0.468531 31.8885C2.91239 28.1803 5.27878 24.4229 7.56748 20.6163Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6658 20.6159C16.1548 20.5803 17.6421 20.6159 19.128 20.7233C16.7115 24.4079 14.3452 28.1294 12.0291 31.8881C10.6044 32.0666 9.18463 32.0307 7.76971 31.7808C10.1588 28.1095 12.4574 24.3879 14.6658 20.6159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ecb9315acebae7e09344298e75ae9e22.svg";
export { ForwardRef as ReactComponent };